import React, { useState } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import NewsTelop from "../components/NewsTelop";
import UserContractRequestPage from "../components/user_contract_request/pages/UserContractRequestPage";
import ProjectRequestEdit from "../components/user_contract_request/pages/ProjectRequestEdit";
import UserJobRequestPage from "../components/user_job_request/pages/UserJobRequestPage";
import JobRequestEdit from "../components/user_job_request/pages/JobRequestEdit";
import AppRouter from "../AppRouter";
import "react-toastify/dist/ReactToastify.css";
import ToastProvider from "../components/shared/ToastProvider";
import CompanyUsers from "../components/company/users/CompanyUsers";
import UnreadProvider from "../components/shared/unread/UnreadProvider";
import CompanyIndexPage from "../components/admin/pages/index/CompanyIndexPage";
import { hasPendingRedirectToast } from "../components/utils/responseHandler";

const AppRouterContainer = (props) => {
  const [isSkillSheetBasicCompleted, setIsSkillSheetBasicCompleted] = useState(
    props.isSkillSheetBasicCompleted,
  );

  return (
    <AppRouter
      {...props}
      isSkillSheetBasicCompleted={isSkillSheetBasicCompleted}
      setIsSkillSheetBasicCompleted={setIsSkillSheetBasicCompleted}
    />
  );
};

document.addEventListener("DOMContentLoaded", async () => {
  // ======== Redirect Toast Fallback (React未マウント画面向け) ========
  const hasToastManagedReactMount = !!document.querySelector(
    ".react-app-router, .react-user-contract-request, .react-user-job-request",
  );
  const hasFallbackToastRoot = !!document.getElementById("redirect-toast-root");
  const hasExistingToastContainer = !!document.querySelector(".Toastify");
  if (
    !hasToastManagedReactMount &&
    !hasFallbackToastRoot &&
    !hasExistingToastContainer &&
    hasPendingRedirectToast()
  ) {
    const toastRootElement = document.createElement("div");
    toastRootElement.id = "redirect-toast-root";
    document.body.appendChild(toastRootElement);

    const toastRoot = createRoot(toastRootElement);
    toastRoot.render(<ToastProvider>{null}</ToastProvider>);
  }

  // ======== NewsTelop ========
  const reactNewsTelopContainers =
    document.querySelectorAll(".react-news-telop");
  reactNewsTelopContainers.forEach((container) => {
    if (container) {
      const dataset = container.dataset;
      const props = {
        newsContent: dataset.newsContent,
      };
      const reactNewsTelopRoot = createRoot(container);
      reactNewsTelopRoot.render(
        <React.StrictMode>
          <NewsTelop {...props} />
        </React.StrictMode>,
      );
    }
  });

  // ======== UserContractRequestPage (プロジェクト希望条件閲覧)  ========
  const userContractRequestContainers = document.querySelectorAll(
    ".react-user-contract-request",
  );
  userContractRequestContainers.forEach((container) => {
    if (container) {
      const dataset = container.dataset;
      const userContractRequestInfo = dataset.userContractRequestInfo
        ? JSON.parse(dataset.userContractRequestInfo)
        : {};
      const userContractRequest = dataset.userContractRequest
        ? JSON.parse(dataset.userContractRequest)
        : {};
      const flashMessage = dataset.flashMessage
        ? JSON.parse(dataset.flashMessage)
        : null;
      const jobRecruitingFlag = dataset.jobRecruitingFlag
        ? JSON.parse(dataset.jobRecruitingFlag)
        : false;

      const props = {
        userContractRequestInfo,
        userContractRequest,
        flashMessage,
        jobRecruitingFlag,
      };

      const userContractRequestRoot = createRoot(container);
      userContractRequestRoot.render(
        <ToastProvider>
          <React.StrictMode>
            <UserContractRequestPage {...props} />
          </React.StrictMode>
        </ToastProvider>,
      );
    }
  });

  // ======== ProjectRequestEdit(プロジェクト希望条件編集)  ========
  const projectRequestEditContainers = document.querySelectorAll(
    ".react-user-contract-request-edit",
  );
  projectRequestEditContainers.forEach((container) => {
    if (container) {
      const dataset = container.dataset;
      const userContractRequest = dataset.userContractRequest
        ? JSON.parse(dataset.userContractRequest)
        : {};
      const flashMessage = dataset.flashMessage
        ? JSON.parse(dataset.flashMessage)
        : null;
      const props = {
        userContractRequest,
        flashMessage,
        csrfToken: dataset.csrfToken,
        formAction: dataset.formAction,
      };

      const root = createRoot(container);
      root.render(
        <React.StrictMode>
          <ProjectRequestEdit {...props} />
        </React.StrictMode>,
      );
    }
  });

  // ======== UserJobRequestPage (求人希望条件閲覧)  ========
  const userJobRequestContainers = document.querySelectorAll(
    ".react-user-job-request",
  );
  userJobRequestContainers.forEach((container) => {
    if (container) {
      const dataset = container.dataset;
      const userJobRequestInfo = dataset.userJobRequestInfo
        ? JSON.parse(dataset.userJobRequestInfo)
        : {};
      const userJobRequest = dataset.userJobRequest
        ? JSON.parse(dataset.userJobRequest)
        : {};
      const flashMessage = dataset.flashMessage
        ? JSON.parse(dataset.flashMessage)
        : null;
      const prefectures = dataset.prefectures
        ? JSON.parse(dataset.prefectures)
        : [];
      const contractRecruitingFlag = dataset.contractRecruitingFlag
        ? JSON.parse(dataset.contractRecruitingFlag)
        : false;

      const props = {
        userJobRequestInfo,
        userJobRequest,
        flashMessage,
        csrfToken: dataset.csrfToken,
        formAction: dataset.formAction,
        prefectures,
        contractRecruitingFlag,
      };

      const userJobRequestRoot = createRoot(container);
      userJobRequestRoot.render(
        <ToastProvider>
          <React.StrictMode>
            <UserJobRequestPage {...props} />
          </React.StrictMode>
        </ToastProvider>,
      );
    }
  });

  // ======== JobRequestEdit (求人希望条件編集) ========
  const jobRequestEditContainers = document.querySelectorAll(
    ".react-user-job-request-edit",
  );
  jobRequestEditContainers.forEach((container) => {
    if (container) {
      const dataset = container.dataset;
      const userJobRequest = dataset.userJobRequest
        ? JSON.parse(dataset.userJobRequest)
        : {};
      const flashMessage = dataset.flashMessage
        ? JSON.parse(dataset.flashMessage)
        : null;

      const props = {
        userJobRequest,
        flashMessage,
        csrfToken: dataset.csrfToken,
        formAction: dataset.formAction,
      };

      const root = createRoot(container);
      root.render(
        <React.StrictMode>
          <JobRequestEdit {...props} />
        </React.StrictMode>,
      );
    }
  });

  // ======== company_users (担当者) ========
  const container = document.getElementById("company-users-root");
  if (container) {
    const root = createRoot(container);
    root.render(
      <BrowserRouter>
        <CompanyUsers />
      </BrowserRouter>,
    );
  }

  // ======== CompanyIndexPage (企業一覧) ========
  const companyIndexContainer = document.getElementById("company-index-root");

  if (companyIndexContainer) {
    const dataset = companyIndexContainer.dataset;
    const flashMessage = dataset.flashMessage
      ? JSON.parse(dataset.flashMessage)
      : null;

    const root = createRoot(companyIndexContainer);
    root.render(
      <ToastProvider>
        <BrowserRouter>
          <CompanyIndexPage flashMessage={flashMessage} />
        </BrowserRouter>
      </ToastProvider>,
    );
  }

  // ======== AppRouter（ルーティング全体） ========
  const appRouterContainers = document.querySelectorAll(".react-app-router");
  appRouterContainers.forEach((container) => {
    if (container) {
      const dataset = container.dataset;
      const flashMessage = dataset.flashMessage
        ? JSON.parse(dataset.flashMessage)
        : null;
      const currentUser = dataset.currentUser
        ? JSON.parse(dataset.currentUser)
        : null;
      const currentCompanyUser = dataset.currentCompanyUser
        ? JSON.parse(dataset.currentCompanyUser)
        : null;
      const userJobRequestExists =
        dataset.userJobRequestExists === undefined
          ? undefined
          : dataset.userJobRequestExists === "true";
      const isSkillSheetBasicCompleted =
        dataset.isSkillSheetBasicCompleted === undefined
          ? undefined
          : dataset.isSkillSheetBasicCompleted === "true";

      const props = {
        flashMessage,
        currentUser,
        currentCompanyUser,
        csrfToken: dataset.csrfToken,
        formAction: dataset.formAction,
        targetUserId: dataset.targetUserId,
        targetUserType: dataset.targetUserType,
        workHistory: dataset.workHistory
          ? JSON.parse(dataset.workHistory)
          : null,
        userJobRequestExists,
        withdrawalAuthType: dataset.withdrawalAuthType || "password",
        withdrawalProvider: dataset.withdrawalProvider || null,
        isSkillSheetBasicCompleted,
      };

      const shouldMountUnreadProvider = !!currentUser;

      const appRoot = createRoot(container);
      appRoot.render(
        <ToastProvider>
          <React.StrictMode>
            {shouldMountUnreadProvider ? (
              <UnreadProvider initialUnread={null}>
                <AppRouterContainer {...props} />
              </UnreadProvider>
            ) : (
              <AppRouterContainer {...props} />
            )}
          </React.StrictMode>
        </ToastProvider>,
      );
    }
  });
});
